export const globalColors = {
      jetBlack: '#1E201E',
      darkMaroon: '#721c24',
      greenPea: "#399918",
      red: '#FF0000',
      beige: '#FFFDF7',
      amber: '#F57C00',
      lightPink: '#FFF7F7',
      crimson: '#D12424',
      lavender: '#F9F7FF',
      indigo: '#562AAD',
      lightBlue: '#F3F9FF',
      dodgerBlue: '#0D6FD0',
      paleTurquoise: '#E3FEF7',
      teal: '#135D66',
      gainsboro: '#FBFBFB',
      gray: '#999999',
  }
export const BASE_PIE_COLORS = [
  '#94A3B8', // Slate 400
  '#38BDF8', // Sky 400
  '#60A5FA', // Blue 400
  '#818CF8', // Indigo 400
  '#A78BFA', // Violet 400
  '#C084FC', // Purple 400
  '#E879F9', // Fuchsia 400
  '#F472B6', // Pink 400
  '#FB7185', // Rose 400
  '#F87171', // Red 400
  '#FB923C', // Orange 400
  '#FBBF24', // Amber 400
  '#FACC15', // Yellow 400
  '#A3E635', // Lime 400
  '#4ADE80', // Green 400
  '#34D399', // Emerald 400
  '#2DD4BF', // Teal 400
  '#22D3EE', // Cyan 400
  '#A1A1AA', // Zinc 400
  '#A8A29E', // Stone 400
];
export const OTHERS_COLOR = "#B0BEC5";